/* eslint-disable react/no-danger */
// @flow
import React from 'react';
import cx from 'classnames';
import { escapeScriptTags } from '../../util';
import styles from './styles.scss';

type Props = {
  id: string,
  html: ?string,
  theme: string,
  checkboxText: ?string,
  onCheckChange: (e: Event & SyntheticEvent<HTMLInputElement>) => void,
  isChecked: ?boolean,
};

const Below = ({ id, html, checkboxText, onCheckChange, isChecked, theme }: Props) => (
  <section id={styles.container}>
    <label htmlFor={`agreement_checkbox_${id}`}>
      <input
        className={styles[theme]}
        id={`agreement_checkbox_${id}`}
        type="checkbox"
        onChange={onCheckChange}
        checked={isChecked}
      />{' '}
      {checkboxText}
      <span className={styles.fake} />
    </label>
    <p className={cx(styles.toc, styles[theme])} dangerouslySetInnerHTML={{ __html: escapeScriptTags(html) }} />
  </section>
);

Below.defaultProps = {
  html:
    '<a href="#">楽天会員情報</a>にご登録されているPCメールアドレス宛に、楽天市場より〇〇ニュースをお送りいたします。メルマガ購読を希望されない方は、チェックを外してください。',
  checkboxText: 'エントリーしてメルマガを購読する',
};

export default Below;



// WEBPACK FOOTER //
// ./src/components/Below/Below.js